import React, { useReducer } from "react";

import axiosClient from "../../config/axios";
import ReceiverReducer from "./ReceiverReducer";
import ReceiverContext from "./ReceiverContext";
import {
    ERROR,
    FETCH_COMPLETED,
    PUSH_COMPLETED ,
    DELETE_COMPLETED,
    UPDATE_COMPLETED,
    SET_CURRENT_TYPE,
    SET_HISTORY,
    SET_CURRENT_ITEM,
    SET_SHOW_EDIT_RECEIVER,
    SUB_ERROR,
    RECEIVER_CLEAR,
    UPDATE_FIELDS
} from "./ReceiverStates";

//TODO move where belong
const GET = 1
const POST = 2
const PUT = 3
const DELETE = 4

const ReceiverState = (props) => {

  const [state, dispatch] = useReducer(ReceiverReducer, {
    receivers:null,
    maxPerPage:10,
    currentPage:1,
    filterCriteria:''
  });

  async function baseAxios(url, method, data , options=null){
     let errType = ERROR
     try {
          let response
          let type=FETCH_COMPLETED
          const token = localStorage.getItem('token')//TODO use the context token and header
          switch(method){
            case GET:
                 response = await axiosClient.get(url,{headers:{'Authorization':'Bearer '+token}})
            break
            case POST:
                 type=PUSH_COMPLETED
                 errType = SUB_ERROR
                 response = await axiosClient.post(url,data,{headers:{'Authorization':'Bearer '+token}});
            break
            case PUT:
                 type=UPDATE_COMPLETED
                 errType = SUB_ERROR
                 response = await axiosClient.put(url,data,{headers:{'Authorization':'Bearer '+token}});

            break
            case DELETE:
                 type=DELETE_COMPLETED
                 response = await axiosClient.delete(url,{headers:{'Authorization':'Bearer '+token},data});
            break
            default: throw {errorMessage:'WTF!'}
          }
          dispatch({
            type: type,
            payload: response.data??null,
            options:options??null
          });
    } catch (error) {
        if(error.response&&error.response.data&&error.response.data.errors){
            try{
                dispatch({
                    type: errType,
                    payload:error.response.data.errors[Object.keys(error.response.data.errors)[0]][0],
                    options
                  })
            }catch(err2){
              dispatch({
                type: errType,
                payload:err2,
                options
              })
            }
        }else{
            dispatch({
              type: errType,
              payload:error,
              options
            })
        }
        setTimeout(()=>{
           dispatch({
              type: RECEIVER_CLEAR
            })
          },10000)
    }
  }
  const getReceiver = async (customerId,type,filterCriteria='',currentPage=1,maxPerPage=10) => {
      try {
        if(!customerId) throw {errorMessage:"getReceiver->customerId missing"}
        if(!type) throw {errorMessage:"getReceiver->type missing"}
        const url = `/Receiver?customerId=${customerId}&type=${type}&filterCriteria=${filterCriteria}&CurrentPage=${currentPage}&MaxPerPage=${maxPerPage}`
        baseAxios(url,GET,null,{maxPerPage})
      } catch (error) {
          //console.log(error)
      }
  }
  const postReceiver = (payload) => {
    try {
      baseAxios("/Receiver",POST, payload)
    } catch (error) {
        //console.log(error)
    }
  }
  const putReceiver =  (payload) => {
      try {
        receiversClearResults()
        baseAxios("/Receiver",PUT, payload)
      } catch (error) {
          //console.log(error)
      }
  }
  const deleteReceiver =  (payload) => {
        try {
          receiversClearResults()
          baseAxios("/Receiver",DELETE, payload)
        } catch (error) {
            //console.log(error)
        }
    }
  const postReceiverExcel =  (payload) => {
        try {
          receiversClearResults()
          baseAxios("/ReceiverExcel",POST, payload)
        } catch (error) {
            //console.log(error)
        }
   }
   const setCurrentType = (currentType)=>{
       dispatch({
         type: SET_CURRENT_TYPE,
         payload:{currentType}
       });
   }
   const setHistory = (history)=>{
          dispatch({
            type: SET_HISTORY,
            payload:{history}
          });
      }
  const setShowEditReceiver = (showEditReceiver)=>{
        dispatch({
          type: SET_SHOW_EDIT_RECEIVER,
          payload:{showEditReceiver}
        });
    }
  const setCurrentItem = (currentItemId)=>{
          dispatch({
            type: SET_CURRENT_ITEM,
            payload:{currentItemId}
          });
      }
  const receiversClearResults = ()=>{
      dispatch({
          type: RECEIVER_CLEAR
        });
      }
  const setCurrentPage = (newCurrentPage)=>{
    dispatch({
        type: UPDATE_FIELDS,
        payload: { currentPage : newCurrentPage }
      });
  }
  const setMaxPerPage = (newMax)=>{
      dispatch({
          type: UPDATE_FIELDS,
          payload: { maxPerPage : newMax }
        });
  }
  const setFilterCriteria = (newFilter)=>{
    dispatch({
        type: UPDATE_FIELDS,
        payload: { filterCriteria : newFilter }
      });
  }
  return (
    <ReceiverContext.Provider
      value={{
        ...state,
        setShowEditReceiver,
        setCurrentType,
        setCurrentItem,
        setHistory,
        getReceiver,
        postReceiver,
        putReceiver,
        deleteReceiver,
        postReceiverExcel,
        receiversClearResults,
        setCurrentPage,
        setMaxPerPage,
        setFilterCriteria
      }}
    >
      {props.children}
    </ReceiverContext.Provider>
  );
};

export default ReceiverState;
